(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOEditor"), require("FEGOVue"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOEditor", "FEGOVue"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/lottery2/render"] = factory(require("FEGORender"), require("FEGOEditor"), require("FEGOVue"));
	else
		root["/fego/component/lottery2/render"] = factory(root["FEGORender"], root["FEGOEditor"], root["FEGOVue"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__4183__, __WEBPACK_EXTERNAL_MODULE__9666__) => {
return 